import React from "react";
import {
    Box,
    Text,
} from "@chakra-ui/react";

function HomePage() {

    return (
        <Box p={4}>
            <Text>Home page</Text>
        </Box>
    );
}

export default HomePage;
